import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "components/layout";

import "./App.css";
import AppPage from "pages/app";
import DetailPage from "pages/detail";
import WalletConnectPage from "pages/walletConnect";
import SetupStakingPage from "pages/setup_staking";
import SetupDetailPage from "pages/setup_detail";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path={""} element={<AppPage />} />
          <Route path={"detail/:pool_id"} element={<DetailPage />} />
          <Route path={"wallet_connect"} element={<WalletConnectPage />} />
          <Route path={"setup_staking"} element={<SetupStakingPage />} />
          <Route path={"setup_detail"} element={<SetupDetailPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
